import * as React from 'react'

/**
 * "Resize" icon used in the Batch / add-menu rail button.
 * Matches Figma node 10852-4161 / "IconForFlathingMenu24X type=Ratio":
 * a 20×20 rounded-rect border with a diagonal expand-arrow overlaid in the
 * centre-right area. Different from Icons.Resize (the three-frame icon).
 */
function AddMenuResizeIcon({ size = 24, color = '#111111' }: { size?: number; color?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer rounded rect border — 2px inset, 2px stroke, rx 2 */}
      <rect x="2" y="2" width="20" height="20" rx="2" stroke={color} strokeWidth="2" />
      {/* Diagonal expand arrow (Figma Group 12057) placed top-left → bottom-right overlap:
          original viewBox 11.8516×11.8525 → translate(6, 6) fits the Figma insets 25%/25% */}
      <g transform="translate(6, 6)">
        <path
          d="M5.24023 0C5.79241 0 6.24143 0.444869 6.24316 0.997075C6.24478 1.54926 5.79831 1.99827 5.24609 2L3.41504 2.00489L9.84863 8.43848L9.85156 6.6084C9.85218 6.05627 10.3005 5.60902 10.8525 5.60938C11.4046 5.61015 11.8521 6.05824 11.8516 6.61036L11.8467 10.2432C11.8455 11.124 11.1328 11.8381 10.252 11.8408L6.61133 11.8525C6.05926 11.854 5.61014 11.4076 5.6084 10.8555C5.60677 10.3036 6.05265 9.85472 6.60449 9.85254L8.43457 9.84668L2.00195 3.41407L2 5.24414C1.99939 5.79638 1.55125 6.24371 0.999024 6.24317C0.44679 6.24255 0 5.79441 0 5.24219L0.00390672 1.60938C0.00503734 0.728637 0.717906 0.0146935 1.59863 0.0117231L5.24023 0Z"
          fill={color}
        />
      </g>
    </svg>
  )
}

export default AddMenuResizeIcon
